import React, { FC } from 'react';
import { RomanticDetails } from '../RomanticDetails';
import { HalloweenDetails } from '../HalloweenDetails';
import { MarchDetails } from '../MarchDetails';
import { MiragoshaDetails } from '../MiragoshaDetails/MiragoshaDetails';
import { EasterDetails } from '../EasterDetails';
import { WednesdayDetails } from '../WednesdayDetails';
import { MaslenitsaDetails } from '../MaslenitsaDetails';
import { SchoolDetails } from '../SchoolDetails/SchoolDetails';
import { HarryDetails } from '../HarryDetails';

type BoxesComponents = 'romantic' | 'halloween' | 'march' | 'miragosha' | 'easterbox' | 'wednesday' | 'maslenitsa' | 'school' | 'harry';

interface IBoxesDetailsProps {
    id: BoxesComponents
}

const BoxesDetailsMap: Record<BoxesComponents, FC> = {
    romantic: RomanticDetails,
    halloween: HalloweenDetails,
    march: MarchDetails,
    miragosha: MiragoshaDetails,
    easterbox: EasterDetails,
    wednesday: WednesdayDetails,
    maslenitsa: MaslenitsaDetails,
    school: SchoolDetails,
    harry: HarryDetails,
};

export const BoxesDetails: FC<IBoxesDetailsProps> = ({ id }: IBoxesDetailsProps) => {
    const CurrentComponent: any = BoxesDetailsMap[id];
    return <CurrentComponent id={id} />;
};
